<header>
  <div
    class="contract-info"
    [class.can-search]="canSearchContracts === true || isAdvisor === true"
    [ngClass]="{ 'usa-contract': isUsaContract }"
  >
    <div class="branding">
      <div class="branding__new-container">
        <div class="branding__logo mark mark__trading mark--animated">
          <div class="full-circle">
            <div class="half--right">
              <div class="fill"></div>
            </div>
            <div class="half--left">
              <div class="fill"></div>
            </div>
          </div>
          <div class="half-circle">
            <div class="half">
              <div class="fill"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let item of contractInfoItems">
      <div
        class="{{ item.class }}"
        *ngIf="!isUsaContract || isUsaContract === item.visibleUsa"
      >
        <div class="header-item">
          <span class="label">{{
            isUsaContract ? item.labelUsa : item.label
          }}</span>
          <span
            class="value"
            [ngClass]="{
              'secure-amount': isUsaContract && item.value === 'buyingPower'
            }"
            *ngIf="
              controls.showInfo &&
              headerContractInfo[item.value].visible &&
              !skeleton
            "
            data-recording-sensitive
            (click)="handleBuyingPowerSecureAmount(item)"
          >
            {{
              headerContractInfo[item.value].total | hbCustomFormat: '$0,0.00'
            }}
          </span>
          <span
            *ngIf="
              (!controls.showInfo || !headerContractInfo[item.value].visible) &&
              !skeleton
            "
            class="value"
            >- -</span
          >
          <span *ngIf="skeleton" class="value skeleton"></span>
        </div>
      </div>
    </ng-container>

    <div class="contract" *ngIf="!canSearchContracts">
      <div class="header-item">
        <span *ngIf="currentContract" class="label"
          >ID: {{ currentContract?.contractID }}</span
        >
        <span *ngIf="!currentContract" class="value skeleton"></span>
        <div
          class="contracts-combo-wrapper"
          (click)="toggleMenuContract($event)"
          (clickOutside)="toggleMenuForceClose('.contracts-combo', $event)"
        >
          <hb-contracts-combo></hb-contracts-combo>
        </div>
      </div>
    </div>

    <div
      #supportCode
      class="client noselect"
      *ngIf="!canSearchContracts"
      (clickOutside)="setSupportCodeVisibility(false)"
      [attachOutsideOnClick]="true"
    >
      <div class="header-item">
        <span class="label" *ngIf="!isUsaContract"
          >{{ currentContract?.rating }} {{ currentContract?.comission }}</span
        >
        <span class="label" *ngIf="isUsaContract">Nombre</span>
        <div class="value-container">
          <span
            class="value"
            data-hj-suppress=""
            [class.skeleton]="!currentContract"
            data-recording-sensitive
          >
            {{ currentContract?.clientName }}
          </span>
        </div>
      </div>
      <div
        class="support-code support-code__container"
        [class.support-code__container--visible]="isSupportCodeVisible"
      >
        <div class="support-code__help-menu">
          <span>
            En caso de fallas con la plataforma, por favor proporciona el
            siguiente código al asesor:
          </span>
          <span>
            <copy-text-value
              [message]="'Código copiado'"
              [value]="support.code"
              [showIcon]="true"
            ></copy-text-value>
          </span>
        </div>
      </div>
    </div>

    <hb-contracts-search
      class="client contract-search"
      *ngIf="canSearchContracts === true && isAdvisor === false"
      [initContract]="currentContract"
      [isInternalUser]="true"
    ></hb-contracts-search>

    <hb-advisor-search
      class="client advisor-search"
      *ngIf="isAdvisor === true"
    ></hb-advisor-search>

    <div class="controls">
      <div class="controls__icon-clickable-area" (click)="toggleUserPrivacy()">
        <div>
          <img
            src="images/icons/atm-icn-{{
              controls.showInfo ? 'show' : 'hide'
            }}.svg"
            alt="{{
              controls.showInfo ? 'Esconder información' : 'Mostrar información'
            }}"
          />
        </div>
      </div>
      <div
        *ngIf="enablePriceAlerts$ | async"
        class="controls__icon-clickable-area"
        (click)="handleAlertsClick()"
      >
        <div>
          <img src="images/icons/atm-bell.svg" />
        </div>
      </div>

      <div
        class="controls__icon-clickable-area"
        (click)="isMoreOptionsMenuOpen = !isMoreOptionsMenuOpen"
        (clickOutside)="isMoreOptionsMenuOpen = false"
      >
        <div>
          <img src="images/icons/atm-icn-more.svg" />
        </div>

        <div
          class="toggleable-submenu__container"
          *ngIf="isMoreOptionsMenuOpen"
          (click)="$event.stopPropagation()"
        >
          <a
            class="toggleable-submenu__item"
            href="https://invertir.gbm.com/conoce-gbmplus"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="toggleable-submenu__item-icon">
              <img src="images/icons/atm-icn-mnu-help.svg" />
            </span>
            <span class="toggleable-submenu__item-text"> Tutoriales </span>
          </a>
          <div
            *ngIf="isLoremAccount && !thematicStrategy"
            (click)="handleEditStrategy(); $event.stopPropagation()"
            class="toggleable-submenu__item"
          >
            <span class="toggleable-submenu__item-icon">
              <img src="images/icons/atm-cta-edit.svg" />
            </span>
            <span class="toggleable-submenu__item-text"> Editar nombre </span>
          </div>
          <a class="toggleable-submenu__item" [href]="elPatronUrl.URL_SETTINGS">
            <span class="toggleable-submenu__item-icon">
              <img src="images/icons/atm-icn-mnu-padlock.svg" />
            </span>
            <span class="toggleable-submenu__item-text"> Seguridad </span>
          </a>
          <!-- TODO: Uncomment when removing strategies is possible -->
          <!-- <div
            (click)="isMoreOptionsMenuOpen = false; $event.stopPropagation()"
            class="toggleable-submenu__item toggleable-submenu__item--destructive"
          >
            <span class="toggleable-submenu__item-icon">
              <img src="images/icons/atm-icn-delete.svg" />
            </span>
            <span class="toggleable-submenu__item-text">
              Eliminar estrategia
            </span>
          </div> -->
        </div>
      </div>

      <div class="controls__icon-clickable-area" (click)="logout()">
        <div>
          <img alt="logout" src="/images/icons/atm-icn-mnu-exit.svg" />
        </div>
      </div>
    </div>
  </div>

  <nav class="nav-secondary" [class.scrolled]="scrolled">
    <div class="nav-secondary__title">{{ tradingTitle }}</div>
    <div class="nav-container">
      <div class="items-container">
        <ng-container *ngFor="let link of mainMenu">
          <a
            *ngIf="link.type === 'link' && link.shouldHide === false"
            class="items"
            [attr.data-text]="link.name"
            routerLink="{{ link.url }}"
            routerLinkActive="active"
            [tourAnchor]="link.tourAnchor || null"
            [attr.data-tour-anchor]="link.tourAnchor || null"
          >
            {{ link.name }}
          </a>
          <ng-container
            *ngIf="link.type === 'dropdown' && link.shouldHide === false"
          >
            <div
              class="items parent-link"
              [attr.data-text]="link.name"
              (click)="toggleMenu($event, isVisibleMenu, link.menuClass)"
              (clickOutside)="toggleMenu($event, true, link.menuClass)"
              routerLinkActive="active"
              [tourAnchor]="link.tourAnchor || null"
              [attr.data-tour-anchor]="link.tourAnchor || null"
            >
              {{ link.name }} <span class="arrow"></span>
              <div
                class="submenu"
                [ngClass]="link.submenu"
                (click)="toggleMenu($event, isVisibleMenu, link.menuClass)"
              >
                <ng-container *ngFor="let sublink of link.childs">
                  <a
                    class="submenu-item"
                    routerLink="{{ sublink.url }}"
                    *ngIf="sublink.shouldHide === false"
                  >
                    {{ sublink.name }}
                  </a>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </nav>
  <div class="indexes" [class.scrolled]="scrolled">
    <hb-indexes
      class="band-container high-contrast"
      [orientation]="orientation"
      [withGraph]="withGraph"
    >
    </hb-indexes>
  </div>
  <div class="notice-bars" [class.scrolled]="scrolled">
    <div
      class="notice-bar notice-bar--geolocation"
      *ngIf="shouldShowGeolocationNoticeBar$ | async"
      [class.scrolled]="scrolled"
    >
      <div class="text">
        {{ geolocationNotificationMessage }}
        <button class="as-text" (click)="onGeolocationLearnMore()">
          Conoce cómo
        </button>
      </div>
    </div>

    <div
      class="notice-bar notice-bar--read-only"
      *ngIf="isReadOnlySession"
      [class.scrolled]="scrolled"
    >
      <div class="text">
        Esta sesión sólo es de consulta de información. Si tienes alguna duda
        por favor comunícate con tu asesor o con nuestro centro de atención a
        inversionistas.
      </div>
    </div>
  </div>
</header>
<app-strategy-edition
  *ngIf="showEditStrategyControl"
  (onHide)="toggleEditStrategy()"
>
</app-strategy-edition>

<app-side-modal #sideModal (goBack)="handleCloseSideModal()">
  <hb-buying-power-secure-amount></hb-buying-power-secure-amount>
</app-side-modal>
